exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desplegable-perfil .dropdown-toggle:after{display:inline-block;margin-left:0;vertical-align:.255em;content:\"\";border-top:.6em solid #0078cf;border-right:.6em solid transparent;border-bottom:0;border-left:.6em solid transparent}.desplegable-perfil button{background:#ff000000!important;color:#212121!important;border:none!important}.desplegable-perfil button:focus{outline:none!important;box-shadow:none!important}.desplegable-perfil ul.dropdown-menu{right:0!important}.desplegable-perfil .dropdown-item.active,.desplegable-perfil .dropdown-item:active{color:#212121;background-color:#e7e7e7}.desplegable-perfil .dropdown-item{padding:1rem 1.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e0ae828c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header/HeaderPlataforma.vue
// module id = 1060
// module chunks = 1